import { App as AntApp, ConfigProvider, theme as antdTheme } from 'antd';
import Main from './Main';
import { ThemeProvider, useTheme } from './contexts/ThemeContext';

function AppContent() {
  const { isDark } = useTheme();



  return (
    <ConfigProvider
      componentSize="large"
      theme={{
        algorithm: isDark ? antdTheme.darkAlgorithm : antdTheme.defaultAlgorithm,
        token: {
          colorPrimary: '#5F33E1',
          borderRadius: 8,
          fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
          colorBgBase: isDark ? '#0D1020' : '#FAFAFE',
          colorTextBase: isDark ? '#F8FAFC' : '#1A1A2E',
        },
      }}
    >
      <AntApp>
        <Main />
      </AntApp>
    </ConfigProvider>
  );
}

function App() {
  return (
    <ThemeProvider>
      <AppContent />
    </ThemeProvider>
  );
}

export default App;
